import { useEffect, useRef } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { API } from '@/shared/api';
import { getGA4ClientId } from '@/shared/lib/attribution';
import { User } from '@/shared/types/User';

import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

export const useSyncGA4ClientId = (user?: User) => {
  const queryClient = useQueryClient();
  const isSent = useRef(false);

  useEffect(() => {
    if (!user || user.ga4_client_id || isSent.current) return;

    const clientId = getGA4ClientId();
    if (!clientId) return;

    isSent.current = true;

    void API.saveGA4ClientId(clientId)
      .then(({ ga4_client_id }) => {
        queryClient.setQueryData<User>(USER_QUERY_KEYS.userData, (current) =>
          current ? { ...current, ga4_client_id } : current,
        );
      })
      .catch(() => undefined);
  }, [queryClient, user]);
};
